import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function Footer({ role }) {

  const theme = useTheme();
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "background.paper",
        textAlign: "center",
        marginTop:"2%",
        py: 0.5,
        boxSizing: "border-box"
      }}
    >
      <Box sx={{ display: "inline-block", textAlign: "center"}}>
        <a href="https://www.nouvelle-marque.com/">
          <Box
            component="img"
            src="/assets/logoNM.png"
            alt="logo"
            sx={{ display: "block", maxHeight: 120, width: "auto", mx: "auto", mb: 1 }}
          />
        </a>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, textDecoration: "underline", color : theme.palette.mode === 'dark' ? "white" : "black" }}>
          <Box component="a" href="https://www.nouvelle-marque.com/">
            <Typography sx={{ fontWeight: 500 }}>Mentions légales</Typography>
          </Box>
          <Box component="a" href="https://www.nouvelle-marque.com/">
            <Typography sx={{ fontWeight: 500 }}>Politique de confidentialité</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
